import React, { useEffect, useRef, useState } from "react";
import { FaChevronRight, FaFilter, FaRegTimesCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import Modal from "react-modal";
import Skeleton from "react-loading-skeleton";
Modal.setAppElement('#root');


function Mobile({ orderListData, selectedStatuses, onSearchChange, onStatusFilterChange, isLoading, errorMessage, loadMore, hasMore, onItemClick, statusId }) {

    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalClass, setModalClass] = useState("");
    const [searchBoxValue, setSearchBoxValue] = useState(""); // Local state for search box value
    const [selectedStatusState, setSelectedStatusState] = useState([statusId]);

    const listRef = useRef();
    useEffect(() => {
        const scrollContainer = listRef.current;

        const handleScroll = () => {
            if (
                scrollContainer &&
                scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 200
            ) {
                console.log('========new laoding============================');
                loadMore(); // ✅ Call API to get next 20
            }
        };

        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", handleScroll);
        }
        scrollContainer.addEventListener("scroll", handleScroll);

        return () => {
            if (scrollContainer) {
                scrollContainer.removeEventListener("scroll", handleScroll);
            }
        };
    }, [loadMore]);


    // useEffect(() => {
    //     setTimeout(() => {
    //         onStatusFilterChange([statusId]);
    //     }, 100);
    // }, [statusId]);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchBoxValue(value);  // Update local state with the search input value
        onSearchChange(value);  // Pass the value to the parent for filtering
    };

    const showFilter = () => {
        setIsOpen(true);
        setTimeout(() => setModalClass("modalSlideIn"), 10);
    };

    const handleCheckboxChange = (statusValue) => {
        const updatedStatuses = selectedStatuses.includes(statusValue)
            ? selectedStatuses.filter((status) => status !== statusValue)
            : [...selectedStatuses, statusValue];

        setSelectedStatusState(updatedStatuses);
        onStatusFilterChange(updatedStatuses); // Trigger fetch in parent
    };


    const filteredData = orderListData;

    const closeModal = () => {
        setModalClass(""); // Remove class to reset position
        setTimeout(() => {
            setIsOpen(false);
        }, 300); // Wait for the animation to finish
    };

    const orderStatus = [
        { label: "Shipment Pending", value: 48 },
        // { label: "Ready for Pickup", value: 49 },
        { label: "In-transit", value: 40 },
        { label: "Delivered", value: 41 },
        { label: "Cancelled", value: 50 },
        { label: "Not Dispatched", value: 51 },
    ];

    return (
        <div className="warehouseCardsec">
            <div className="row alignmentTable">
                <div className="col-12 col-md-2">
                    <input
                        type="text"
                        className="searchInputField"
                        placeholder="Search Shop Name"
                        value={searchBoxValue}  // Bind to local state
                        onChange={handleInputChange}  // Update local state and pass to parent
                    />
                </div>
                <div className="col-12 mt-3">
                    <div className="inventoryFilterlists">
                        {orderStatus
                            .filter((item) => selectedStatuses.includes(item.value))
                            .map((item, index) => (
                                <div className="form-check form-check-inline selected-filter-item" key={index} style={{ position: 'relative', marginRight: '0px', paddingLeft: 0 }}>
                                    {/* <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={item.value}
                                        id={`readonlyCheck${index}`}
                                        checked
                                        disabled
                                    /> */}
                                    <label
                                        // className="form-check-label"
                                        className={`form-check-label me-2 mb-2 filterbg ${item.value === 41 ? 'delivered' :
                                            item.value === 40 ? 'intransit' :
                                                item.value === 50 ? 'bg-danger' :
                                                    item.value === 48 ? 'pending' :
                                                        ''
                                            }`}
                                        htmlFor={`readonlyCheck${index}`}>
                                        {item.label}
                                    </label>
                                    {/* <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={() => handleCheckboxChange(item.value)} // Use same handler to toggle off
                                        style={{
                                            position: 'absolute',
                                            top: '-5px',
                                            right: '-5px',
                                            background: 'transparent',
                                            border: 'none',
                                            fontSize: '14px',
                                            color: '#ff0000',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        ×
                                    </button> */}
                                </div>
                            ))}
                        {/* {selectedStatuses.length === 0 && <p>No filters selected</p>} */}
                    </div>
                </div>
            </div>
            {/* {isLoading ? (
                <div style={{ marginTop: 50, padding: "0 20px" }}>
                    <Skeleton count={5} height={40} style={{ marginBottom: 10 }} />
                </div>
            ) : ( */}
            <div className="row mt-3">
                <div className="col-sm-12">
                    <div className="scroll-wrapper" ref={listRef}>

                        <ul className="cardlisting">
                            {filteredData.length === 0 ? (
                                <li className="noOrdersMsg">No Orders Found</li>
                            ) : (
                                filteredData.map((item, index) => (
                                    <li
                                        key={index}
                                        className={`baseClass ${item.shipmentStatusId == 41
                                            ? "green"
                                            : item.shipmentStatusId == 48
                                                ? "yellow"
                                                : "grey"
                                            }`}
                                    >
                                        <Link
                                            to={{
                                                pathname: `/WarehouseOrderDetail/${item?.orderId}`,
                                                state: { item }, // Pass data to the route
                                            }}
                                            onClick={() => onItemClick(item)} // Trigger callback with item data
                                        >
                                            <div>
                                                <div className="d-flex justify-content-between">
                                                    <div><b className="me-1">#{item?.orderId}</b></div>
                                                    <div className="text-truncate-shopname">{item?.shopName}</div>
                                                </div>
                                                <div className="mt-1 d-flex justify-content-between align-items-center">
                                                    <div style={{ color: "#999" }}>
                                                        {item?.mobileNumber} | <span>{item?.orderDate || "-"}</span>
                                                    </div>
                                                    <div className="viewicon">
                                                        <button className="btn btn-primary">
                                                            <FaChevronRight />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                ))
                            )}
                        </ul>
                    </div>

                    <div className="filersec">
                        <button type="button" className="btn btn-primary filtersBtn" onClick={showFilter}>
                            <FaFilter />
                        </button>
                    </div>
                </div>
            </div>
            {/* )} */}



            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Warehouse Modal"
                className={`ReactModal__Content ${modalClass}`}
                overlayClassName="ReactModal__Overlay"
            >
                <button className="modalCloseBtn" onClick={closeModal}>
                    <FaRegTimesCircle />
                </button>
                <h4 className="pleaseSelectStatus">Filters</h4>
                <ul className="filtersList">
                    {orderStatus.map((item, index) => (
                        <li key={index}>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value={item.value}
                                    id={`flexCheckDefault${index}`}
                                    // checked={statusId}
                                    checked={selectedStatusState.includes(item.value) ? 'checked' : ''}
                                    onChange={() => handleCheckboxChange(item.value)}
                                />
                                <label className="form-check-label" htmlFor={`flexCheckDefault${index}`}>
                                    {item.label}
                                </label>
                            </div>
                        </li>
                    ))}
                </ul>
            </Modal>
        </div>
    );
}

export default Mobile;
